import { useTranslation } from 'next-i18next';

import { useAlertDialog } from '../../hooks';

export function useAuthErrorDialog() {
  const alertDialog = useAlertDialog();
  const { t } = useTranslation(['common']);

  const open = async () => {
    return alertDialog.open({
      title: t('googleClassroom.authErrorDialog.title'),
      content: t('googleClassroom.authErrorDialog.content'),
    });
  };

  const close = () => {
    alertDialog.close();
  };

  return { open, close, didOpen: alertDialog.didOpen };
}
